import { Container, Row, Col, Card, Modal, Button } from 'react-bootstrap';
import { useState } from 'react';
import tmlogo from '../../assets/logos/tmiLogoGold400x317.png'

export const Info = ({ homePageData }) => {
  const [activeCard, setActiveCard] = useState(null); // State to manage the active card for the modal
  const handleCloseModal = () => setActiveCard(null);

  if (!homePageData?.info?.visible) {
    return null; // Do not render the section if it's not visible
  }

  return (
    <section className='info' id="info">
      <Container>
        {/* Title Section */}
        {homePageData.info.title?.visible && (
          <Row className="text-center">
            <h2 className='mb-5'>{homePageData.info.title.text}</h2>
          </Row>
        )}

        {/* Short Description Section */}
        {homePageData.info.shortDescription?.visible && (
          <Row className="text-center mb-5">
            <p>{homePageData.info.shortDescription.text}</p>
          </Row>
        )}

        {/* Cards Section */}
        <Row>
          {homePageData.info.cards?.map((card, index) => {
            if (!card.visible) return null; // Skip cards that are not visible

            return (
              <Col xs={12} md={6} xl={4} key={`infoCard${index}`}>
                <Card className="info-cardbx text-center" variant="dark" style={{ height: "265px" }}>
                  {/* Top Section with Image and Title */}
                  <div>
                    <img
                      src={tmlogo}
                      alt={card.title.text}
                      className='mt-3 mb-2'
                      style={{ maxHeight: '120px', objectFit: 'contain' }}
                    />
                    <h2 style={{ fontSize: "35px", color: "#D38C50" }} className='mt-3'>{card.title.text}</h2>
                  </div>

                  {/* Card Content */}
                  <div className='info-txtx' style={{ padding: '15px' }}>
                    <h4>{card.title.text}</h4>
                    {card.subtitle.visible && <span>{card.subtitle.text}</span>}
                    <br /><br />
                    <Button onClick={() => setActiveCard(card)}>Read more</Button>
                  </div>
                </Card>
              </Col>
            );
          })}
        </Row>

        {/* Modal for Card Details */}
        {activeCard && (
          <Modal show={!!activeCard} onHide={handleCloseModal} data-bs-theme="dark" size="lg" >
            <Modal.Header closeButton>
              <Modal.Title>{activeCard.title.text}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {/* {activeCard.subtitle.visible && <h2>{activeCard.subtitle.text}</h2>} */}
              <div className='announcement-modal' dangerouslySetInnerHTML={{ __html: activeCard.description.text }}></div>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleCloseModal}>Close</Button>
            </Modal.Footer>
          </Modal>
        )}
      </Container>
    </section>
  );
};